module.exports = __webpack_public_path__ + "img/logout.223c5398.svg";